/**
 * @generated SignedSource<<ce5520b9694fad232e50da1e00746e5a>>
 * @relayHash 32c09513109ed7bcffc202a4b4be2530
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 32c09513109ed7bcffc202a4b4be2530

import { ConcreteRequest } from 'relay-runtime';
export type deCallButtonQuery$variables = {
  id: string;
};
export type deCallButtonQuery$data = {
  readonly callLineInformation: {
    readonly callLine: string;
    readonly isRecorded: boolean;
  };
};
export type deCallButtonQuery = {
  response: deCallButtonQuery$data;
  variables: deCallButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "callLineInformation",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CallLineOutput",
    "kind": "LinkedField",
    "name": "de_callLineInformationByPatientId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callLine",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRecorded",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deCallButtonQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deCallButtonQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "32c09513109ed7bcffc202a4b4be2530",
    "metadata": {},
    "name": "deCallButtonQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "49508f0173a614900c23fde523fbbeaa";

export default node;
